import { TemplateVariableDefinitionDto } from '@/features/dashboard/messageTemplates/types/TemplateVariableDefinitionDto.ts';
import { isBlockVariable } from '../templateVariableUtils.ts';
import {
  TEMPLATE_VARIABLE_ATTR,
  TEMPLATE_VARIABLE_BLOCK_ATTR,
} from '../templateVariableAttrs.ts';
import {
  hasImageHelper,
  resolveImagePreviews,
} from '../image/imageWireFormat.ts';

const VARIABLE_PATTERN = /\{\{\s*([\w.]+)\s*}}/g;

// Parses backend `{{key}}` syntax into HTML markers TipTap recognizes, and (when
// an image resolver is supplied) turns `{{image '<id>'}}` references into
// previewable `<img>` nodes. Inverse of `convertTiptapToTemplate`.
export const convertTemplateToTiptap = (
  templateHtml: string,
  variables: TemplateVariableDefinitionDto[] = [],
  resolveImageUrl?: (fileId: string) => string | undefined,
): string => {
  const withVariables = insertVariableMarkers(templateHtml, variables);

  return resolveImageUrl && hasImageHelper(withVariables)
    ? resolveImagePreviews(withVariables, resolveImageUrl)
    : withVariables;
};

// Replaces backend `{{key}}` tokens with the HTML markers TipTap parses into
// variable nodes — a `<div>` for block variables, a `<span>` for inline ones.
const insertVariableMarkers = (
  html: string,
  variables: TemplateVariableDefinitionDto[],
): string => {
  const blockKeys = new Set(
    variables.filter(isBlockVariable).map((v) => v.key),
  );

  return html.replace(VARIABLE_PATTERN, (_, key) =>
    blockKeys.has(key)
      ? `<div ${TEMPLATE_VARIABLE_BLOCK_ATTR}="${key}"></div>`
      : `<span ${TEMPLATE_VARIABLE_ATTR}="${key}">${key}</span>`,
  );
};
